import { innerSearch } from 'api/Api';
import LoadingIndicator from 'app/components/LoadingIndicator';
import PayverseHeader from 'app/components/PayverseHeader';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect, useState, useCallback } from 'react';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

function isWebView(): boolean {
  const userAgent = navigator.userAgent.toLowerCase();
  return (
    userAgent.includes('wv') || //Android Webview
    userAgent.includes('version/4.0') || //old Android Webview
    (userAgent.includes('applewebkit') && !userAgent.includes('safari')) // IOS Webview
  );
}

const WechatResult = () => {
  const searchParams = useLocation().search;
  const navigate = useNavigate();
  const { setPaymentState } = usePaymentState();
  const [webviewStatus, setWebviewStatus] = useState<boolean>(true);
  const [tid, setTid] = useState<string>();
  const [appScheme, setAppScheme] = useState<string>();

  const handleGotoApp = useCallback((scheme: string) => {
    window.location.href = scheme;
  }, []);

  useEffect(() => {
    setWebviewStatus(isWebView());
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(searchParams);
    const tid = urlParams.get('tid');
    const appScheme = urlParams.get('appScheme');

    if (tid) {
      setTid(tid);
      setPaymentState(prev => ({ ...prev, tid }));
    }
    if (appScheme) {
      setAppScheme(appScheme);
    }
  }, [searchParams, setPaymentState]);

  useEffect(() => {
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isIOS) {
      if (!webviewStatus && appScheme) {
        handleGotoApp(appScheme);
      } else {
        tid && transactResult.mutate();
      }
    } else {
      tid && transactResult.mutate();
    }
  }, [webviewStatus, appScheme, handleGotoApp, tid]);

  const transactResult = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      const resultStatus = data?.data?.response?.resultStatus;
      if (!resultStatus) {
        navigate('/error');
        return;
      }
      if (resultStatus === 'SUCCESS') {
        processPaymentResult(data);
      } else {
        startPolling(data.data);
      }
    },
    onError: () => navigate('/error'),
  });

  const transactPolling = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      const resultStatus = data?.data?.response?.resultStatus;
      if (!resultStatus) {
        navigate('/error');
        return;
      }
      if (resultStatus === 'SUCCESS') {
        processPaymentResult(data);
      }
    },
    onError: () => navigate('/error'),
  });

  const transactLastResult = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      const resultStatus = data?.data?.response?.resultStatus;
      if (!resultStatus) {
        navigate('/error');
        return;
      } else {
        processPaymentResult(data);
      }
    },
    onError: () => navigate('/error'),
  });

  const startPolling = (initialData: any) => {
    const intervalId = setInterval(() => transactPolling.mutate(), 2000);

    setTimeout(() => {
      transactLastResult.mutate();
      clearInterval(intervalId);
    }, 10000);

    return () => clearInterval(intervalId);
  };

  const processPaymentResult = (data: any) => {
    const resultStatus = data?.data?.response?.resultStatus?.toLowerCase();
    const payType = data?.data?.display?.payType?.toLowerCase();

    setPaymentState(prev => ({
      ...prev,
      returnUrl: data.data.returnUrl,
      resultCode: data.data.response.resultCode,
      mallReserved: data.data.response.mallReserved,
      orderId: data.data.response.orderId,
      resultMessage: data.data.response.resultMessage,
      requestAmount: data.data.display.requestAmount,
      requestCurrency: data.data.display.requestCurrency,
      reqDate: data.data.display.responseDateTime,
      descriptor: data.data.display.descriptor,
      schemeGroup: data.data.response.schemeGroup,
      schemeCode: data.data.response.schemeCode,
    }));

    switch (resultStatus) {
      case 'success':
        navigate('/success');
        break;
      case 'decline':
        navigate('/decline');
        break;
      case 'processing':
        navigate('/processing');
        break;
      case 'pending':
        payType === 'vbank' || payType === 'otc'
          ? navigate('/vbankPending')
          : navigate('/pending');
        break;
      case 'failed':
        navigate('/failed');
        break;
      default:
        navigate('/error');
    }
  };

  return (
    <div className="payverse-wrap">
      <div className="payverse">
        <PayverseHeader />
        <LoadingIndicator />
        <div className="d-section">
          <div className="box">
            <div className="copy">
              Copyright (c) eromnet Co., Ltd. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WechatResult;
